import React from "react";

const SuccessDisburseModal = ({
  isSuccessDisburseModalOpen,
  closeSuccessDisburseModal,
}) => {
  return (
    <>
      <div
        className={`${
          isSuccessDisburseModalOpen ? "flex" : "hidden"
        } flex items-center justify-center fixed inset-0 z-20 overflow-auto bg-gray-800 bg-opacity-50`}
      >
        <div className="relative bg-white shadow max-w-[38%] mx-auto p-6 rounded-sm text-center">
          <h2
            id="success-modal-title"
            className="text-black text-lg font-semibold mt-4"
          >
            SUCCESS!
          </h2>
          <div className="w-20 h-20 bg-[#8ED6A8] rounded-full flex items-center justify-center mx-auto">
            <img src="/green-tick.png" alt="Success" className="w-12 h-12" />
          </div>

          <p className="text-black text-sm mt-2">
            Disbursement Details Successfully Recorded. The loan disbursement
            information has been saved and processed.
          </p>

          <button
            onClick={closeSuccessDisburseModal}
            className="border border-[#005C53] text-[#005C53] w-[251px] max-w-sx h-12 rounded-lg mt-[54px]"
          >
            Close
          </button>
        </div>
      </div>
    </>
  );
};

export default SuccessDisburseModal;
